import { render, staticRenderFns } from "./MSCI.vue?vue&type=template&id=5bec030f&scoped=true&"
import script from "./MSCI.vue?vue&type=script&lang=js&"
export * from "./MSCI.vue?vue&type=script&lang=js&"
import style0 from "./MSCI.vue?vue&type=style&index=0&id=5bec030f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec030f",
  null
  
)

export default component.exports